import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import Question from "@/components/Question.vue";
import QuizHeader from "@/components/QuizHeader.vue";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import quizes from "@/data/quizes.json";
import Result from "@/components/Result.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuizView',
  setup(__props) {

const route = useRoute();
let quizId = route.params.id;
const currentQuestionIndex = ref(0);
const quiz = quizes.find((q) => `${q.id}` === quizId);
const numberOfCorrectAnswer = ref(0);
const length = quiz?.questions.length;
const showResult = ref(false);

const questionStatus = computed(
  () => `${currentQuestionIndex.value + 1}/${quiz?.questions.length}`
);

const barPercentage = computed(() => {
  if (typeof length !== "undefined")
    return `${((currentQuestionIndex.value + 1) / length) * 100}%`;
});

const onOptionSelected = (isCorrect: boolean) => {
  if (isCorrect) {
    numberOfCorrectAnswer.value++;
  }
  if (quiz?.questions.length === currentQuestionIndex.value + 1) {
    showResult.value = true;
  } else {
    currentQuestionIndex.value++;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(QuizHeader, {
        questionStatus: questionStatus.value,
        barPercentage: barPercentage.value
      }, null, 8, ["questionStatus", "barPercentage"])
    ]),
    _createElementVNode("div", null, [
      (!showResult.value)
        ? (_openBlock(), _createBlock(Question, {
            key: 0,
            question: _unref(quiz).questions[currentQuestionIndex.value],
            onSelectOption: onOptionSelected
          }, null, 8, ["question"]))
        : (_openBlock(), _createBlock(Result, {
            key: 1,
            quizQuestionLength: _unref(quiz)?.questions.length,
            numberOfCorrectAnswer: numberOfCorrectAnswer.value
          }, null, 8, ["quizQuestionLength", "numberOfCorrectAnswer"]))
    ])
  ]))
}
}

})